import noop from 'lodash/noop';

export const defaultProps = {
  filters: [],
  visible: false,
  applyFilter: noop,
  changeFilterContainerVisibility: noop,
  updateActiveTab: noop,
  updateFilterConditions: noop,
  pushDrilldownFilter: noop,
};
